import { useState } from "react";
import { Card, Space, Tabs, Typography } from "antd";
import { useAuth } from "../lib/auth";
import RoleGate from "../components/RoleGate";
import ApiKeysTab from "../components/settings/ApiKeysTab";
import AuditLogTab from "../components/settings/AuditLogTab";
import ProjectTemplatesTab from "../components/settings/ProjectTemplatesTab";
import UsersTab from "../components/settings/UsersTab";

type SettingsTab = "apiKeys" | "users" | "templates" | "auditLog" | "general";

export default function Settings() {
  const { isAdmin } = useAuth();
  // "My API Keys" is the natural landing tab for non-admins (it's the only
  // self-service action they have here). Admins still default to Users.
  const [activeTab, setActiveTab] = useState<SettingsTab>(isAdmin ? "users" : "apiKeys");

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Card>
        <Typography.Title level={2} style={{ marginBottom: 0 }}>
          Settings
        </Typography.Title>
        <Typography.Text type="secondary">
          Manage the OAIP allowlist, audit history, and system-wide settings.
        </Typography.Text>
      </Card>

      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as SettingsTab)}
        items={[
          {
            key: "apiKeys",
            label: "My API Keys",
            children: <ApiKeysTab />,
          },
          {
            key: "users",
            label: "Users",
            children: (
              <RoleGate allow="admin">
                <UsersTab />
              </RoleGate>
            ),
          },
          {
            key: "templates",
            label: "Project Templates",
            children: (
              <RoleGate allow="admin">
                <ProjectTemplatesTab />
              </RoleGate>
            ),
          },
          {
            key: "auditLog",
            label: "Audit Log",
            children: (
              <RoleGate allow="admin">
                <AuditLogTab />
              </RoleGate>
            ),
          },
          {
            key: "general",
            label: "General",
            children: (
              <Card>
                <Typography.Text type="secondary">
                  General settings coming soon...
                </Typography.Text>
              </Card>
            ),
          },
        ]}
      />
    </Space>
  );
}
